import { useEffect, useState } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import type { Tipo } from 'cofre-biometrico';
import { deveOferecer, ligarBiometria, marcarPerguntado, nomeDaBiometria, OFERECER_AGORA } from './entradaBiometrica';

/**
 * A PERGUNTA, UMA VEZ (1.4): depois de um login com SENHA (o `login` deixa a marca `OFERECER_AGORA` na sessão), no
 * aplicativo, com biometria disponível e se esta conta ainda não foi perguntada neste aparelho.
 */
export function OfertaDeBiometria() {
  const { user } = useAuth();
  const [tipo, setTipo] = useState<Tipo | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);

  useEffect(() => {
    if (!user) return;
    let agora = false;
    try { agora = sessionStorage.getItem(OFERECER_AGORA) === '1'; sessionStorage.removeItem(OFERECER_AGORA); } catch { agora = false; }
    if (!agora || user.trocaDeSenhaObrigatoria) return;
    void deveOferecer(Number(user.id)).then((t) => { if (t) setTipo(t); });
  }, [user]);

  if (!tipo || !user) return null;
  const nome = nomeDaBiometria(tipo);
  const fechar = () => { marcarPerguntado(Number(user.id)); setTipo(null); };
  const sim = async () => {
    setOcupado(true); setErro(null);
    try { await ligarBiometria({ id: Number(user.id), username: user.username, name: user.name }, tipo); fechar(); }
    catch { setErro('Não foi possível ligar agora. Você pode tentar no próximo login.'); setOcupado(false); }
  };
  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center bg-black/50 p-4 sm:items-center" data-testid="oferta-de-biometria">
      <div className="w-full max-w-sm rounded-lg bg-white p-5 shadow-xl">
        <h2 className="text-base font-semibold text-tinta">Usar {nome} para entrar neste aparelho?</h2>
        <p className="mt-2 text-sm text-gray-600">Na próxima vez, você entra sem digitar a senha. A senha não fica guardada no aparelho, e sempre dá para entrar com ela.</p>
        <p className="mt-2 text-sm text-amber-800">Não recomendado em celular compartilhado: quem tiver a {nome} cadastrada no aparelho entra na sua conta.</p>
        {erro && <p className="mt-2 text-sm text-red-700" role="alert">{erro}</p>}
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={fechar} className="min-h-[44px] rounded-md border border-gray-300 px-4 text-sm">Agora não</button>
          <button type="button" onClick={() => void sim()} disabled={ocupado} className="min-h-[44px] rounded-md bg-marca-600 px-4 text-sm font-semibold text-white disabled:opacity-50" data-testid="ligar-biometria">{ocupado ? 'Ligando…' : `Usar ${nome}`}</button>
        </div>
      </div>
    </div>
  );
}
